import script from "./Chapter7Popup.vue?vue&type=script&setup=true&lang=js"
export * from "./Chapter7Popup.vue?vue&type=script&setup=true&lang=js"

import "./Chapter7Popup.vue?vue&type=style&index=0&id=07a81b2e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07a81b2e"]])

export default __exports__